import {useSignals} from '@preact/signals-react/runtime'
import React, {forwardRef, useImperativeHandle, useRef} from 'react'
import {useAuth} from '../../authentication/AuthProvider'
import {component} from '../../form/Constant'
import {useListPathways} from '../../pathway/query-keys/PathwayKeysManager'
import StyledDropdown from '../components/StyledDropdown'
import StyledMultiSelect from '../components/StyledMultiSelect'

const StyledPathwayOptions = forwardRef(
    (
        {
            value = null,
            onChange = () => {},
            placeholder = 'Select Pathway',

            hasPanelFooter = true,
            optionType = component.dropdownGroup,
            groupByIsNull = null,
        },
        ref,
    ) => {
        useSignals()
        useImperativeHandle(ref, () => ({
            getValue: () => handleGetValue(),
            changeValue: newValue => handleChangeValue(newValue),
        }))

        //#region Context
        const {user} = useAuth()
        // const {}
        //#endregion

        //#region Value
        const optionRef = useRef(null)

        const handleGetValue = () => {
            return optionRef.current?.getValue()
        }

        const handleChangeValue = newValue => {
            optionRef.current?.changeValue(newValue)
        }
        //#endregion

        //#region Dropdown
        const {data: options} = useListPathways(user?.id, true, {}, !!user?.id)

        const valueTemplate = (option, props) => {
            if (option) {
                return (
                    <div className="flex align-items-center">
                        {option.data ? (
                            <img
                                alt={option.label}
                                src={option.data}
                                className={`mr-2`}
                                style={{width: '48px', height: '20px'}}
                            />
                        ) : (
                            <i
                                className="pi pi-home mr-2"
                                style={{fontSize: '16px'}}></i>
                        )}

                        <div className="font-bold">{option.label}</div>
                    </div>
                )
            }

            return <span>{props.placeholder}</span>
        }

        const itemTemplate = option => {
            return (
                <div className="flex align-items-center">
                    <div
                        className="flex align-items-center justify-content-center mr-2"
                        style={{width: '48px'}}>
                        {option.data ? (
                            <img
                                alt={option.label}
                                src={option.data}
                                className={`mr-2`}
                                style={{width: '60%', height: '24px'}}
                            />
                        ) : (
                            <div>
                                <i
                                    className="pi pi-home"
                                    style={{fontSize: '20px'}}></i>
                            </div>
                        )}
                    </div>
                    <div className="font-bold">{option.label}</div>
                </div>
            )
        }
        //#endregion

        //#region MultiSelect
        const multiSelectItemTemplate = option => {
            return (
                <div className="flex align-items-center">
                    <div
                        className="flex align-items-center justify-content-center mr-2"
                        style={{width: '48px'}}>
                        {option.data ? (
                            <img
                                alt={option.label}
                                src={option.data}
                                className={`mr-2`}
                                style={{width: '60%', height: '24px'}}
                            />
                        ) : (
                            <div>
                                <i
                                    className="pi pi-home"
                                    style={{fontSize: '20px'}}></i>
                            </div>
                        )}
                    </div>
                    <div className="font-bold">
                        <h6 className="m-0 mb-1">{option.label}</h6>
                        <small>
                            Current number of patients: {option?.extraData}
                        </small>
                    </div>
                </div>
            )
        }
        //#endregion

        return (
            <React.Fragment>
                {optionType === component.dropdown && (
                    <StyledDropdown
                        ref={optionRef}
                        options={options || []}
                        value={value}
                        onChange={onChange}
                        placeholder={placeholder}
                        itemTemplate={itemTemplate}
                        valueTemplate={valueTemplate}
                        showClear={true}
                        hasPanelFooter={hasPanelFooter}
                        optionType={component.dropdown}
                    />
                )}

                {optionType === component.multiSelect && (
                    <StyledMultiSelect
                        ref={optionRef}
                        options={options || []}
                        value={value}
                        onChange={onChange}
                        placeholder={placeholder}
                        itemTemplate={multiSelectItemTemplate}
                        showClear={true}
                    />
                )}
            </React.Fragment>
        )
    },
)

export default StyledPathwayOptions
